// extracted by mini-css-extract-plugin
export default {"errContainer":"ErrorBoundry_errContainer__qcmCq"};